export type ProjectStatus = "en-venta" | "proximamente" | "vendidos";

export interface Project {
  id: string;
  slug: string;
  name: string;
  status: ProjectStatus;
  statusLabel: string;
  soldLabel?: string;
  comuna: string;
  address: string;
  homes: number;
  description: string;
  features: string[];
  image: string;
  gallery: string[];
  video?: string;
  highlighted?: boolean;
}

export const projects: Project[] = [
  {
    id: "carmen-de-huechuraba",
    slug: "carmen-de-huechuraba",
    name: "Carmen de Huechuraba",
    status: "en-venta",
    statusLabel: "En venta",
    soldLabel: "70% vendido",
    comuna: "Huechuraba",
    address: "Avenida Los Libertadores 6811, Huechuraba",
    homes: 20,
    description:
      "Condominio estratégicamente ubicado en Avenida Los Libertadores 6811, diseñado para ofrecer un estilo de vida seguro y tranquilo. Su arquitectura de estilo Mediterráneo integra un concepto moderno y funcional en un condominio compuesto por 20 casas.",
    features: [
      "20 casas",
      "3 dormitorios",
      "3 baños",
      "Home office",
      "Cocina integrada",
      "Juegos infantiles",
      "Bicicletero",
    ],
    image:
      "https://storage.helloreaddy.io/project_files/7cb346ee-08b8-4aed-8389-778a643bccf0/f7d0acba-c352-4553-af18-5e2f4fee9604_compressed_9ee2d67f-9e54-4cfe-be97-99b5cc7a582f.webp",
    gallery: [
      "https://storage.helloreaddy.io/project_files/7cb346ee-08b8-4aed-8389-778a643bccf0/cbb1b7a2-7478-4f13-9451-f48571db1dc2_compressed_IMG_0720.webp",
      "https://storage.helloreaddy.io/project_files/7cb346ee-08b8-4aed-8389-778a643bccf0/f01f21d1-7d54-4ae8-a61e-1d3f64776206_compressed_8874d0d9-e265-424e-aeee-33084a45592b.webp",
      "https://storage.helloreaddy.io/project_files/7cb346ee-08b8-4aed-8389-778a643bccf0/25c74fe7-12eb-4b79-912e-c6b30d1beba3_compressed_IMG_0795.webp",
      "https://storage.helloreaddy.io/project_files/7cb346ee-08b8-4aed-8389-778a643bccf0/e7d81afc-e5eb-47d0-b6e6-ab7cb528ed85_compressed_IMG_0793.webp",
      "https://storage.helloreaddy.io/project_files/7cb346ee-08b8-4aed-8389-778a643bccf0/6493cf59-d93f-4bb3-9107-4dc5ba8a2abc_compressed_IMG_0790.webp",
    ],
    video:
      "https://storage.helloreaddy.io/project_files/7cb346ee-08b8-4aed-8389-778a643bccf0/40318ec7-e606-4320-923a-8a96fc79725a_e2ef1cf1-58cf-447a-8c6e-349615e213d8.mov",
    highlighted: true,
  },
];

export const projectFilters: { value: ProjectStatus | "todos"; label: string }[] = [
  { value: "todos", label: "Todos" },
  { value: "en-venta", label: "En venta" },
  { value: "proximamente", label: "Próximamente" },
  { value: "vendidos", label: "Vendidos" },
];